import * as angular from 'angular';

import { event } from '../event-channel';
import { Timer } from './timer';
import { ng1FormatTimePipe } from '@go-modules/pipes/format-time/format-time.pipe';

export { TimerBase } from './timer-base';
export { TimerEvent } from './event';
export { Timer };

export const timerModule = angular.module('timer', [
	event
])
	.factory('Timer', () => Timer)
	.filter('ng1FormatTime', ng1FormatTimePipe)
	.name;
